import styled from 'styled-components';

export const Footer = styled.footer`
  background: linear-gradient(135deg, #1E4C5C 0%, #143742 100%);
  color: white;
  padding: 3rem 2rem 2rem;
  text-align: center;
`;

export const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
`;

export const SocialLink = styled.a`
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  text-decoration: none;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  
  &:hover {
    transform: translateY(-3px) scale(1.1);
  }
  
  /* Instagram - gradient with pink shadow */
  &[aria-label="Instagram"]:hover {
    background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
    border-color: #E4405F;
    box-shadow: 0 8px 20px rgba(228, 64, 95, 0.5);
  }
  
  /* Facebook - classic blue with blue shadow */
  &[aria-label="Facebook"]:hover {
    background: #1877F2;
    border-color: #1877F2;
    box-shadow: 0 8px 20px rgba(24, 119, 242, 0.5);
  }
  
  /* TikTok - black with pink shadow */
  &[aria-label="TikTok"]:hover {
    background: #000000;
    border-color: #FE2C55;
    box-shadow: 0 8px 20px rgba(254, 44, 85, 0.5);
  }
  
  /* WhatsApp - green with green shadow */
  &[aria-label="WhatsApp"]:hover {
    background: #25D366;
    border-color: #25D366;
    box-shadow: 0 8px 20px rgba(37, 211, 102, 0.5);
  }
  
  /* YouTube - red with red shadow */
  &[aria-label="YouTube"]:hover {
    background: #FF0000;
    border-color: #FF0000;
    box-shadow: 0 8px 20px rgba(255, 0, 0, 0.5);
  }
`;

export const FooterText = styled.p`
  font-size: 0.9rem;
  opacity: 0.8;
  margin-top: 1rem;
`;
